import type { RuntimeNodeImport } from '@/models/logic/RuntimeGraphIds';
import type Context from '@/context';
import type { ICircuitModel, ITileManagerModel } from '@/interfaces/models';
import { CircuitModel, type CircuitDto } from '@/models/CircuitModel';
import { CircuitType } from '@/schemas/common';
import { TileManagerFactory } from '@/factories/TileManagerFactory';
import { ConnectionModelFactory } from '@/factories/ConnectionModelFactory';

export class CircuitModelFactory {
  constructor(
    private readonly tileManagerFactory: TileManagerFactory,
    private readonly connectionModelFactory: ConnectionModelFactory,
  ) {}

  create(context: Context, circuitType: CircuitType): ICircuitModel {
    const tileManagerModel = this.tileManagerFactory.create(context);
    const connectionModel = this.connectionModelFactory.create(tileManagerModel);

    return new CircuitModel({ circuitType, tileManagerModel, connectionModel });
  }

  fromDto(
    context: Context,
    dto: CircuitDto,
    reuseId = true,
    tileManagerModel?: ITileManagerModel,
    importer?: RuntimeNodeImport,
  ): ICircuitModel {
    tileManagerModel ??= this.tileManagerFactory.fromDto(
      dto.tileManagerDto,
      context,
      importer,
    );
    const connectionModel = this.connectionModelFactory.fromDto(
      tileManagerModel,
      dto.connectionGraphDto,
    );

    return CircuitModel.fromDto(dto, { tileManagerModel, connectionModel, reuseId });
  }

  *tileManagerFromDtoSteps(
    context: Context,
    dto: CircuitDto,
    importer?: RuntimeNodeImport,
    onProgress?: import('@/utils/projectLoadProgress').ProjectLoadWorkObserver,
  ): Generator<void, ITileManagerModel> {
    return yield* this.tileManagerFactory.fromDtoSteps(
      dto.tileManagerDto,
      context,
      importer,
      onProgress,
    );
  }
}
